import IframeEventService from '@/services/IframeEventService';

const IFRAME_TARGET_NAME = 'paycore-redirect-iframe';

const Protocol = {
  redirectFormId: 'redirect_from',
  redirect(data) {
    console.log('redirect data', data);

    if (data && data.action) {
      IframeEventService.emitRedirect(data.action);
    }

    const form = this.formGenerator(data);
    document.getElementsByTagName('body')[0].appendChild(form);
    this.submitForm();
  },
  redirectToIframe(data) {
    const form = this.formGenerator(data);
    form.setAttribute('target', IFRAME_TARGET_NAME);
    document.getElementsByTagName('body')[0].appendChild(form);
    this.submitForm();
  },
  submitForm() {
    document.forms[this.redirectFormId].submit();
  },
  formGenerator(form) {
    const formId = this.redirectFormId;
    const formElement = document.getElementById(formId);
    if (formElement !== null) {
      formElement.outerHTML = '';
    }

    const f = document.createElement('form');
    f.setAttribute('method', form.method);
    f.setAttribute('action', form.action);
    f.setAttribute('id', formId);
    if (form.blank) {
      f.setAttribute('target', '_blank');
    }

    Object.keys(form.params).forEach(key => {
      const value = form.params[key];
      const i = document.createElement('input');
      i.setAttribute('type', 'hidden');
      i.setAttribute('name', key);
      i.setAttribute('value', value);
      f.appendChild(i);
    });

    return f;
  },
};

export default Protocol;
